/* RESPONSIBLE TEAM: team-proactive-support */
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { post } from 'embercom/lib/ajax';
import { markTemplateAsNew } from 'embercom/utils/recently-created-templates';

export default class NewVisualTemplateRoute extends Route {
  @service declare notificationsService: $TSFixMe;
  @service declare router: RouterService;
  @service declare intl: IntlService;

  async createTemplate(transition: Transition) {
    let templateId = transition.to.queryParams['templateId'];
    let app: $TSFixMe = this.modelFor('apps.app');

    try {
      let template = await post('/ember/email_templates', {
        template_id: templateId,
        app_id: app.id,
        type: 'blocks',
      });
      transition.abort();
      markTemplateAsNew(template.id);
      return this.router.replaceWith(
        'apps.app.settings.proactive-support.email-templates.edit-template',
        template.id,
      );
    } catch (error: unknown) {
      transition.abort();
      this.notificationsService.notifyResponseError(error, {
        default: this.intl.t('outbound.settings.email-templates.new-template-error'),
      });
      return this.router.replaceWith('apps.app.settings.proactive-support.email-templates');
    }
  }

  async beforeModel(transition: Transition) {
    this.createTemplate(transition);
  }
}
